<script setup lang="ts">
import type { TpgChangeEvent } from '@tpg/grammar-web';

export interface GrammarSwitchListProps {
  label?: string;
  readOnly?: boolean;
  disabled?: boolean;
  switchType?: 'badge' | 'text';
  secondaryLabel?: string;
  secondaryLabelUom?: string;
  type?: 'neutral' | 'ghost' | 'not-classified' | 'classified' | 'dynamic' | 'accent' | 'ok' | 'error' | 'warning' | 'danger';
  selected?: boolean;
  formAssociated?: boolean;
  name?: string;
}

const props = withDefaults(defineProps<GrammarSwitchListProps>(), {
  label: '',
  readOnly: false,
  disabled: false,
  switchType: 'text',
  secondaryLabel: '',
  secondaryLabelUom: '',
  type: 'neutral',
  selected: false,
  formAssociated: true,
  name: '',
});

const emit = defineEmits(['change']);

function onChange(event: TpgChangeEvent<boolean>) {
  emit('change', event.value);
}
</script>

<template>
  <tpg-switch-list v-bind="props" @tpg-change="onChange" />
</template>
